/**
 * Jembatan antara service worker dan tampilan.
 *
 * `registerServiceWorker.js` berjalan saat main.js diimpor, jauh sebelum
 * komponen Vue mana pun ter-mount (App.vue masih menahan splash screen 3
 * detik). Kalau statusnya cuma disiarkan lewat event, siaran itu bisa lewat
 * begitu saja sebelum ada yang mendengarkan. Karena itu registration-nya
 * DISIMPAN di sini, dan komponen boleh menanyakannya kapan pun ia siap.
 */

let registrationMenunggu = null;

const NAMA_EVENT = "sw:updated";

/** Dipanggil registerServiceWorker.js ketika ada versi baru yang menunggu. */
export function tandaiAdaPembaruan(registration) {
  registrationMenunggu = registration;
  window.dispatchEvent(new CustomEvent(NAMA_EVENT, { detail: registration }));
}

/** Untuk komponen yang baru ter-mount setelah pembaruan terdeteksi. */
export function pembaruanTertunda() {
  return registrationMenunggu;
}

export function dengarkanPembaruan(handler) {
  window.addEventListener(NAMA_EVENT, handler);
  return () => window.removeEventListener(NAMA_EVENT, handler);
}

/**
 * Terapkan versi baru.
 *
 * Service worker hasil build memasang pendengar ini sendiri (Workbox menambahkannya
 * otomatis selama `skipWaiting: false` di vue.config.js):
 *   self.addEventListener("message", e => {
 *     if (e.data && e.data.type === "SKIP_WAITING") self.skipWaiting()
 *   })
 * Tanpa PENGIRIM pesannya, versi baru akan mengendap di status "waiting" sampai
 * seluruh jendela aplikasi ditutup.
 *
 * Halaman dimuat ulang HANYA setelah service worker baru benar-benar
 * mengambil alih (`controllerchange`). Memuat ulang lebih cepat dari itu
 * justru menyajikan aset lama sekali lagi.
 */
export function terapkanPembaruan() {
  const registration = registrationMenunggu;
  const menunggu = registration && registration.waiting;

  // Tidak ada yang menunggu (mis. tombol ditekan dua kali, atau SW keburu
  // aktif sendiri karena aplikasi sempat ditutup). Muat ulang saja.
  if (!menunggu) {
    window.location.reload();
    return;
  }

  let sudahMuatUlang = false;
  const muatUlangSekali = () => {
    if (sudahMuatUlang) return;
    sudahMuatUlang = true;
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener("controllerchange", muatUlangSekali);

  // Jaring pengaman: kalau controllerchange tidak pernah datang (SW gagal
  // aktif), jangan biarkan pengguna menatap tombol yang tidak bereaksi.
  setTimeout(muatUlangSekali, 3000);

  menunggu.postMessage({ type: "SKIP_WAITING" });
}
